/**
 * Language switch (OCP-656) - one button in the navbar that flips between
 * German and English. Persists through the auth context (server + local) so
 * the choice follows the user across devices and drives the language of the
 * mails the portal sends them.
 */
import { useTranslation } from 'react-i18next';

import { LOCALE_LABELS, applyLocale, currentLocale, type PortalLocale } from '../i18n';
import { useOptionalAuth } from '../lib/auth-context';
import { usePortalConfig } from '../lib/portal-config';

export function LocaleToggle() {
  const { t } = useTranslation('common');
  const auth = useOptionalAuth();
  const { localesEnabled } = usePortalConfig();
  const setLocale = auth?.setLocale ?? applyLocale;
  const active = currentLocale();
  const next: PortalLocale = active === 'de' ? 'en' : 'de';
  if (!localesEnabled) return null;
  return (
    <button
      type="button"
      onClick={() => {
        void setLocale(next);
      }}
      title={t('navbar.switchTo', { language: LOCALE_LABELS[next] })}
      aria-label={t('navbar.switchTo', { language: LOCALE_LABELS[next] })}
      data-testid="locale-toggle"
      className="inline-flex h-8 min-w-8 items-center justify-center rounded px-1.5 text-xs font-semibold uppercase tracking-wide text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-100"
    >
      {active}
    </button>
  );
}
